/**
 * Arquivos de segredo do projeto (`.env`, `.env.local`, `.env.production`…). Só o dono e quem tem a
 * permissão "Ver .env" leem o conteúdo: o servidor de sincronização nem envia o documento para os
 * outros, e onde o texto aparece por outro caminho (histórico, marcos, replay) ele vem mascarado.
 * Modelos (`.env.example`, `.env.sample`, `.env.template`) não são segredo.
 */
const SECRET = /(^|\/)\.env(\.(?!example$|sample$|template$)[^/]+)?$/i;

export const isSecretPath = (path: string) => SECRET.test(path.trim());

const KEY_LINE = /^(\s*(?:export\s+)?[A-Za-z_][A-Za-z0-9_.-]*\s*[=:]\s*)(.*)$/;
const DOTS = "••••••••";

/**
 * Esconde os valores mantendo a estrutura: `API_KEY=abc` vira `API_KEY=••••••••`. Comentários e
 * linhas vazias ficam; qualquer outra linha vira pontos (nada do valor passa).
 */
export function maskSecretText(text: string): string {
  return text
    .split("\n")
    .map((line) => {
      if (/^\s*(#.*)?$/.test(line)) return line;
      const m = KEY_LINE.exec(line);
      if (m) return m[2]!.trim() ? `${m[1]}${DOTS}` : m[1]!;
      return line.replace(/\S/g, "•");
    })
    .join("\n");
}

/** Diff (formato unificado) de um arquivo de segredo, com os valores das linhas mascarados. */
export function maskSecretPatch(patch: string): string {
  return patch
    .split("\n")
    .map((line) => {
      if (/^(\+\+\+|---|@@|\\)/.test(line)) return line;
      const sign = line[0];
      if (sign === "+" || sign === "-" || sign === " ") return sign + maskSecretText(line.slice(1));
      return line;
    })
    .join("\n");
}
